import React from 'react'
import { Tile, TileCaption, Button, Icon } from '@mc/design-system'
import { TrackContentType } from '@mc/track-event'
import { VideoOverlay, useVideo } from '@mc/video'
import { VideoPlayer as NewVideoPlayer } from 'components/VideoPlayer'
import { EndScreen } from '../../shared/EndScreen'
import classes from './InlineVideoPlayer.module.scss'

type InlineVideoPlayerProps = {
  videoId?: string
  mediaUuid: string
  onTileClick: () => void
  contentId: string
  contentTitle: string
  contentType: TrackContentType
  extraTrackingInfo: Record<string, unknown>
  pageType: string
  playAriaLabel: string
}

export const InlineVideoPlayer = ({
  videoId,
  mediaUuid,
  onTileClick,
  contentId,
  contentTitle,
  contentType,
  extraTrackingInfo = {},
  pageType,
  playAriaLabel,
}: InlineVideoPlayerProps) => {
  const handleClick = (onResume: () => void) => {
    onResume()
    onTileClick()
  }

  return (
    <div className='container mc-px-0'>
      <div className='mc-overflow--hidden mc-corners--sm'>
        <Tile aspectRatio='16x9' className={classes.maxWidth2k}>
          <NewVideoPlayer
            contentId={contentId}
            contentType={contentType}
            contentTitle={contentTitle}
            extraTrackingParams={extraTrackingInfo}
            videoId={videoId}
            mediaUuid={mediaUuid}
            className='mc-w-100 mc-h-100 mc-theme-dark'
            playsInline
          >
            <VideoOverlay state={['paused', 'ended']} fade>
              <EndScreen pageType={pageType} />
            </VideoOverlay>
            <VideoOverlay state='idle'>
              <NewBeforeScreen
                handleClick={handleClick}
                playAriaLabel={playAriaLabel}
              />
            </VideoOverlay>
          </NewVideoPlayer>
        </Tile>
      </div>
    </div>
  )
}

const BeforeScreen = ({
  onClick,
  playAriaLabel,
}: {
  onClick: () => void
  playAriaLabel?: string
}) => (
  <Tile onClick={onClick}>
    <TileCaption position='center' className='category-catalog__tile-overlay'>
      <Button aria-label={playAriaLabel} kind='link' className={classes.circle}>
        <Icon kind='play-circle' className='mc-icon--9' />
      </Button>
    </TileCaption>
  </Tile>
)

const NewBeforeScreen = ({
  handleClick,
  playAriaLabel,
}: {
  handleClick: (play: () => Promise<void>) => void
  playAriaLabel?: string
}) => {
  const { play } = useVideo()

  return (
    <BeforeScreen
      onClick={() => handleClick(play)}
      playAriaLabel={playAriaLabel}
    />
  )
}
